import $ from 'jquery'
import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import ClipBoard from '@/components/clipboard';
import { ref } from 'vue'

export default {
    name: 'manage-consultation-commentaire',
    components: { VueEditor, ClipBoard },
    props: {
        consultation: Object,
        user_id: Number,
        evolution_id: Number,
        comment_selected: Object,
        slug: String
    },
    data() {
        return {
            info_consultation: {
                id: 0,
                consultation_id: 0,
                user_id: 0,
                data_type: '',
                titre: '',
                content: ''
            },
            save_loading: false,

            del_loading: false,
            is_confirm: false,
            is_error: false,
            permission_is_denied: false,
            customToolbar: vueEditorToolbar,

            is_recording: ref(false),

            recognition: null,
            transcript: '',
            is_listening: false,
        }
    },

    watch: {
        comment_selected() {
            if (this.is_listening) {
                this.stopRecording()
            }

            this.info_consultation = {
                id: (this.comment_selected.id)?this.comment_selected.id:0,
                consultation_id: (this.comment_selected.consultation_id)?this.comment_selected.consultation_id:'',
                user_id: 0,
                data_type: this.slug,
                titre: (this.comment_selected.title)?this.comment_selected.title:'',
                content: (this.comment_selected.content)?this.comment_selected.content:''
            }
        }
    },

    computed: {
        
    },
    
    mounted() {

    },

    methods: {
        async submit() {
            const isValid = await this.$refs.comment_form.validate();

            if (!isValid) {
                return;
            }

            this.info_consultation.consultation_id = this.consultation.id
            this.info_consultation.evolution_id = this.evolution_id
            this.info_consultation.user_id = this.user_id
            this.info_consultation.data_type = this.slug
            this.save_loading = true

            this.$store.dispatch('saveConsultationInfoComplementaire', this.info_consultation).then((response) => {
                if (response.success) {
                    this.successToast("Enregistrement effectué avec succès")
                    this.$emit("emitCommentaire")

                    this.$refs.comment_form.reset()
                    this.$refs.c_comment.click()
                    
                    this.info_consultation = {
                        id: 0,
                        consultation_id: 0,
                        user_id: 0,
                        data_type: '',
                        titre: '',
                        content: ''
                    }
                } else {
                    if (response.code === 401) {
                        this.permission_is_denied = true
                    } else if (response.code === 500) {
                        this.is_error = true
                    }
                }

                if (this.is_listening) {
                    this.stopRecording()
                }
                
                this.save_loading = false
            }).catch(() => {
                this.is_error = true
                this.save_loading = false
            })
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
         onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            let data = {
                data_type: this.slug,
                consultation_id: this.consultation.id,
                info_compl_id: this.comment_selected.id,     // ID commentaire 
                user_id: this.user_id
            }

            this.$store.dispatch('deleteConsultationInfoComplementaire', data).then((response) => {
                if (response > 0) {
                    this.successToast("Suppression effectuée avec succès")
                    this.$emit('emitCommentaire')

                    this.is_confirm = false
                    this.$refs.del_comment.click();
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },

        removeParagraph(text) {
            return text?.replace(/<p>/g, '').replace(/<\/p>/g, '');
        },

        recordSpeech() {
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
            if (!SpeechRecognition) {
                console.log("Browser does not support speech recognnition !");
                return
            }
            this.is_listening = true

            this.recognition = new SpeechRecognition()
            this.recognition.continuous = true
            this.recognition.interimResults = true
            this.recognition.lang = 'fr-FR'

            this.recognition.onend = () => {
                this.is_listening = false
            }

            this.recognition.onresult = (evt) => {
                for (let i = evt.resultIndex; i < evt.results.length; ++i) {
                    this.$refs.txtzone_editor.quill.blur()

                    this.transcript = evt.results[i][0].transcript

                    this.info_consultation.content = this.removeParagraph(this.info_consultation.content)
                    if (evt.results[i].isFinal) {
                        this.info_consultation.content += this.transcript
                    } 
                }
            }

            this.recognition.onerror = (evt) => {
                console.log("Speech recognition error: ",evt);
                this.recognition.stop();
                this.is_listening = false;
            }

            this.recognition.start()
        },

        stopRecording() {
            this.recognition.stop();
            this.is_listening = false;
        
            // Optional: Clear the transcript if you want to start fresh next time
            this.transcript = ""; 
        }
    }
}


